"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FPCTPageFour;
var _formik = require("formik");
var _react = _interopRequireWildcard(require("react"));
var _Form = _interopRequireDefault(require("react-bootstrap/Form"));
var _utmParam = require("../Common/utmParam");
var _FinancialPlanningCheckupFormControls = require("./FinancialPlanningCheckupFormControls");
var _FinancialPlanningCheckupWizardTool = require("./FinancialPlanningCheckupWizardTool.config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function FPCTPageFour() {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = (0, _formik.useFormikContext)();

  // Auto-focus to snap scrolling to top of the stepper/progress bar if user travels back-and-forth between steps
  (0, _react.useEffect)(() => {
    document.getElementById(_FinancialPlanningCheckupWizardTool.calcName).scrollIntoView();
    /* istanbul ignore else */
    if (window) {
      window.scrollBy(0, -112);
    }
  }, []);
  var updateUTMFields = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (trackingInfo) {
      yield setFieldValue('trackingInfo', trackingInfo);
    });
    return function updateUTMFields(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_utmParam.UtmsHidden, {
    updateUTMFields: updateUTMFields
  }), /*#__PURE__*/_react.default.createElement("h4", null, "Let's review your financial plan together"), /*#__PURE__*/_react.default.createElement("p", null, "Explore these solutions with a financial professional to see what might be right for you. After you submit the form, you can download a copy of your financial check-up."), /*#__PURE__*/_react.default.createElement("p", null, "*= required"), /*#__PURE__*/_react.default.createElement(_Form.default, {
    className: "digAn-decorator-frmTrEnable"
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Group, {
    className: "col-md-6"
  }, /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.FirstNameInput, {
    errors: errors,
    touched: touched,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.LastNameInput, {
    errors: errors,
    touched: touched,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.PhoneInput, {
    errors: errors,
    touched: touched,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.EmailInput, {
    errors: errors,
    touched: touched,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.ZipInput, {
    errors: errors,
    touched: touched,
    values: values
  }))), /*#__PURE__*/_react.default.createElement("p", null, "By submitting this request, I agree to receive e-mails and phone calls using automated technology from MassMutual, its financial professionals, affiliates or vendors on its behalf regarding MassMutual products and services, at the e-mail address and phone number above, even if it is for a wireless phone. I understand I can contact a local financial professional directly to make a purchase without consenting to receive calls from MassMutual."));
}